import officePhoto from '../img/escritorio.PNG';
import BannerFoto from '../img/henrique.PNG';

export const CONNECT_INFO = {
  brand: 'Connect Veiculos',
  cnpj: '54.202.137/0001-58',
  whatsappE164: '5511947278793',
  address: 'Av. dos Autonomistas, 2561 - Vila Yara, Osasco - SP, 06090-020',
  officePhoto,
  BannerFoto,
};

export const buildWhatsAppLink = (message) => {
  const base = 'https://wa.me/' + CONNECT_INFO.whatsappE164;
  return base + '?text=' + encodeURIComponent(message);
};

export const WHATSAPP_LINKS = {
  locadora: buildWhatsAppLink('Quero ver o estoque da locadora e agendar uma visita'),
  estoque: buildWhatsAppLink('Quero agendar visita para ver o Estoque Connect'),
  vender: buildWhatsAppLink('Quero avaliar meu carro para venda ou consignacao'),
};

export const HERO_COPY = {
  title: 'Consultoria automotiva premium em Osasco',
  subtitle:
    'Carros selecionados com procedencia, atendimento com hora marcada e opcoes abaixo da FIPE no patio da locadora.',
};
